export default "__VITE_ASSET__vG5L_BvE__"